<template>
  <main id="main" class="main-site">
    <div class="container">
      <div class="wrap-breadcrumb">
        <ul>
          <li class="item-link">
            <router-link to="/loja" class="fa fa-home"></router-link>
          </li>
          <li class="item-link">
            <span>Meu <span v-if="formKombi.tipo == 'carrinho'">Carrinho</span><span v-else-if="formKombi.tipo == 'cotacao'">Cotação</span></span>
          </li>
        </ul>
      </div>
      <div class="main-content-area">
        <div class="main-content-area">
          <div class="row">
            <div class="col-md-12">
              <h3>
                Meu <span v-if="formKombi.tipo == 'carrinho'">Carrinho</span><span v-else-if="formKombi.tipo == 'cotacao'">Cotação</span>:
                {{ formKombi.kombiCode }}
              </h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">Faturamento para venda normal</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <vue-good-table :columns="columnsCli" :rows="formKombi.clienteInfo" :pagination-options="{ enabled: false }" styleClass="vgt-table">
                <template slot="table-row" slot-scope="props">
                  {{ props.formattedRow[props.column.field] }}
                </template>
                <div slot="emptystate">Sem dados para exibição</div>
              </vue-good-table>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">Produtos</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <FormHelper
                :inputVar="formAddProdutos.codigo"
                :form="formAddProdutos"
                :mask="['#-#', '##-#', '###-#', '####-#', '#####-#', '######-#']"
                label="Código"
                placeholder="Ex: 1234-2"
              ></FormHelper>
            </div>
            <div class="col-md-1">
              <FormHelper :inputVar="formAddProdutos.quantidade" :form="formAddProdutos" label="Qtde" mask="####"></FormHelper>
            </div>
            <div class="col-md-1 col-only-button">
              <button aria-label="Adicionar Produto" class="btn primary-button" v-on:click.prevent="addProduto()">
                <i class="fa fa-plus-circle fa-lg" />
              </button>
            </div>
          </div>
          <Loader v-if="formKombi.loading || isCalculating" />
          <div id="in-stock-list">
            <div class="row">
              <div class="col-md-12">
                <div class="instock-info">{{ formKombi.inStockText }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table style="width: 100%">
                  <tr class="cart-table-header">
                    <th class="text-center"><i class="fa fa-times fa-lg" /></th>
                    <th class="text-center">Código</th>
                    <th class="text-center">Foto</th>
                    <th>Descrição</th>
                    <th class="text-center">Qtde</th>
                    <th class="text-center">Valor Unitário</th>
                    <th class="text-center"><i class="fa fa-exclamation-circle fa-lg" /></th>
                  </tr>
                  <tr class="cart-table-data" v-for="(product, index) in formKombi.inStockList" :key="'instock-' + index">
                    <td v-if="product.prodPai == '|0|'" class="text-center">
                      <a class="fa fa-times fa-lg" style="color: red" v-on:click.prevent="removeInStock(index)" href="#" />
                    </td>
                    <td v-else class="text-center"><a class="fa fa-times fa-lg" style="color: gray" /></td>
                    <td class="text-center">
                      <span v-if="product.prodPai != '|0|'"
                        ><strong>Associado<br /></strong></span
                      >{{ product.code }}-{{ product.dv }}
                    </td>
                    <td class="text-center"><img class="cart-table-img" v-bind:src="product.img" /></td>
                    <td>{{ product.desc }}</td>
                    <td v-if="product.prodPai == '|0|'" class="text-center">
                      <input
                        class="form-control cart-num-input"
                        v-model="product.qtde"
                        type="number"
                        min="1"
                        v-bind:disabled="isCalculating"
                        v-on:change="updateQt(product)"
                      />
                    </td>
                    <td v-else class="text-center">
                      <input class="form-control cart-num-input" v-model="product.qtde" type="number" min="1" disabled="true" />
                    </td>
                    <td class="text-center">{{ formatCurrency(product.unitV) }}</td>
                    <td class="text-center">
                      <i class="fa fa-exclamation-circle fa-lg cart-product-info" style="color: #0083ca">
                        <ProductTaxesTooltip :productTaxes="product.taxes" :origin="product.origin" />
                      </i>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div id="out-stock-list">
            <div class="row">
              <div class="col-md-12">
                <div class="outstock-info">{{ formKombi.outStockText }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <table style="width: 100%">
                  <tr class="cart-table-header">
                    <th class="text-center"><i class="fa fa-times fa-lg" /></th>
                    <th class="text-center">Código</th>
                    <th class="text-center">Foto</th>
                    <th>Descrição</th>
                    <th class="text-center">Qtde</th>
                    <th class="text-center">Valor Unitário</th>
                    <th class="text-center"><i class="fa fa-exclamation-circle fa-lg" /></th>
                  </tr>
                  <tr class="cart-table-data" v-for="(product, index) in formKombi.outStockList" :key="'outstock-' + index">
                    <td v-if="product.prodPai == '|0|'" class="text-center">
                      <a class="fa fa-times fa-lg" style="color: red" v-on:click.prevent="removeOutStock(index)" href="#" />
                    </td>
                    <td v-else class="text-center"><a class="fa fa-times fa-lg" style="color: gray" /></td>
                    <td class="text-center">
                      <span v-if="product.prodPai != '|0|'"
                        ><strong>Associado<br /></strong></span
                      >{{ product.code }}-{{ product.dv }}
                    </td>
                    <td class="text-center"><img class="cart-table-img" v-bind:src="product.img" /></td>
                    <td>{{ product.desc }}</td>
                    <td v-if="product.prodPai == '|0|'" class="text-center">
                      <input
                        class="form-control cart-num-input"
                        v-model="product.qtde"
                        type="number"
                        min="1"
                        v-bind:disabled="isCalculating"
                        v-on:change="updateQt(product)"
                      />
                    </td>
                    <td v-else class="text-center">
                      <input class="form-control cart-num-input" v-model="product.qtde" type="number" min="1" disabled="true" />
                    </td>
                    <td class="text-center">{{ formatCurrency(product.unitV) }}</td>
                    <td class="text-center">
                      <i class="fa fa-exclamation-circle fa-lg cart-product-info" style="color: #0083ca">
                        <ProductTaxesTooltip :productTaxes="product.taxes" :origin="product.origin" />
                      </i>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">Vendedor</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <input class="form-control" v-model="formKombi.vendedor.value.label" :readonly="true" v-if="!reativacao" />

              <FormHelper
                :inputVar="formKombi.vendedor"
                :form="formKombi"
                :options="formKombi.vendedores"
                type="select"
                label="Selecione um vendedor"
                placeholder="Vendedor"
                :change="alterarVendedor"
                v-if="reativacao"
              ></FormHelper>
            </div>
          </div>

          <SelectShippingNew
            v-if="formKombi != null"
            :valorTotal="formKombi.baseCalculoFrete"
            v-on:updateCarrinho="this.updateAfterSelectFrete"
            v-on:showLoading="this.showLoading"
            :formulario="this.formulario"
          />

          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">Tipo de pagamento</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12" id="formas-pagamento">
              <FormHelper
                :inputVar="formKombi.formaPag"
                :form="formKombi"
                :options="payForms().filter((pay) => pay.visible == true)"
                :disabled="isConsumoProprio"
                :change="formaPagOnChange"
                type="radio"
                label="Forma de pagamento"
              ></FormHelper>
            </div>
          </div>

          <div class="row" v-if="isPossivelConfirmacaoAut == true && formKombi.formaPag.value === 'vista'">
            <div class="col-md-12">
              <label style="font-weight: bold; font-size: 15px">Precisa de alguma alteração em seu pedido?</label>
              <div class="row">
                <div class="col-md-4">
                  <div class="choose-radio-methods">
                    <label class="inline-radio">
                      <input name="radio-acompanhamento" value="1" type="radio" v-model="formKombi.vendaNaoRealizaAcompanhamento" />
                      <span>Não (Confirmação do pedido e emissão do boleto automaticamente)</span>
                    </label>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="choose-radio-methods">
                    <label class="inline-radio">
                      <input name="radio-tipo-pessoa" value="0" type="radio" checked v-model="formKombi.vendaNaoRealizaAcompanhamento" />
                      <span>Sim (Confirmação do pedido e emissão do boleto pelo vendedor)</span>
                    </label>
                  </div>
                </div>
              </div>
              <hr />
            </div>
          </div>
          <div id="pay-method">
            <div class="row">
              <div class="col-md-4">
                <FormHelper
                  :inputVar="formKombi.meioPag"
                  :form="formKombi"
                  :options="getMeiosPag()"
                  type="select"
                  :disabled="isConsumoProprio"
                  label="Meio de pagamento"
                  placeholder="Meio de pagamento"
                  :change="alterarMeioPagamento"
                ></FormHelper>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="alert alert-warning" role="alert">
                  <i class="fa fa-warning"></i>
                  Pagamentos em "Boleto", o tipo de transportadora poderá ser "O Mesmo" (Retira).
                </div>
              </div>
            </div>
          </div>
          <div id="parcels" class="row">
            <div class="col-md-12">
              <FormHelper
                :inputVar="formKombi.parcelas"
                :form="formKombi"
                :options="formKombi.optionsParcelas"
                type="select"
                label="Parcelas"
                placeholder="Parcelas"
              ></FormHelper>
              <h4 style="color: red">É necessário entrada de 30% para pedidos à prazo.</h4>
            </div>
          </div>
          <div v-if="liberaPagamentoCartaoCredito && this.formKombi.pagCartaoCredito == true" id="cartaocredito" class="row">
            <div class="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <FormHelper
                    :inputVar="formKombi.bandeiraCartao"
                    :form="formKombi"
                    :options="getFlags().filter((pay) => pay.visible == true)"
                    :change="alterarBandeiraCartao"
                    type="radio"
                    label="Bandeira"
                  ></FormHelper>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <Loader v-if="loadingCardValues" />
              <FormHelper
                :inputVar="formKombi.cartaocredito"
                :form="formKombi"
                :options="formKombi.optionsCartaoCredito"
                type="select"
                label="Parcelas Cartão"
                placeholder="Parcelas Cartão"
                :change="alterarParcelaCartao"
                v-if="!loadingCardValues"
              ></FormHelper>
            </div>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-12">
              <h3 class="box-title">Informações</h3>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <vue-good-table :columns="columnsTaxes" :rows="formKombi.taxesInfo" :pagination-options="{ enabled: false }" styleClass="vgt-table">
                <template slot="table-row" slot-scope="props">
                  {{ formatCurrency(props.formattedRow[props.column.field]) }}
                </template>
                <div slot="emptystate">Sem dados para exibição</div>
              </vue-good-table>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <span class="cart-table-foot pull-left">{{ totalItems }} item(s)</span>
            </div>
            <div class="col-md-6">
              <span class="cart-table-foot pull-right">Total do Carrinho: {{ formKombi.totalCarrinho }}</span>
            </div>
          </div>
        </div>
        <div class="row" style="height: 64px">
          <div class="col-md-6">
            <button
              aria-label="Excluir Carrinho"
              class="btn btn-danger"
              v-on:click.prevent="deleteAction()"
              v-bind:disabled="isCalculating || isProcessing"
            >
              Excluir Carrinho
            </button>
          </div>
          <div class="col-md-3">
            <Loader v-if="isCalculating || isProcessing" />
          </div>
          <div class="col-md-3">
            <button
              v-if="formKombi.tipo == 'carrinho'"
              aria-label="Finalizar"
              class="btn btn-primary pull-right"
              v-on:click.prevent="continueAction()"
              v-bind:disabled="isCalculating || isProcessing"
            >
              Finalizar
            </button>
            <button
              v-else-if="formKombi.tipo == 'cotacao'"
              aria-label="Continuar"
              class="btn btn-warning pull-right"
              v-on:click.prevent="continueAction()"
              v-bind:disabled="isCalculating || isProcessing"
            >
              Finalizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import 'vue-good-table/dist/vue-good-table.css'
import FormHelper from './partials/FormHelper.vue'
import ProductTaxesTooltip from './partials/ProductTaxesTooltip'
import { VueGoodTable } from 'vue-good-table'
import Loader from './partials/Loader'
import axios from 'axios'
import { convertNumberToReal } from '../Utils/formatNumber'
import SelectShippingNew from './SelectShippingNew'
import CarrinhoService from '@/services/CarrinhoService'
import $ from 'jquery'
import swal from 'sweetalert'

export default {
  name: 'MyKombiCart',
  components: {
    VueGoodTable,
    FormHelper,
    ProductTaxesTooltip,
    Loader,
    SelectShippingNew,
  },
  mounted() {
    const self = this
    $('#in-stock-list').hide()
    $('#out-stock-list').hide()

    var $mpag = $('#pay-method')
    var $parcels = $('#parcels')
    var $cartaocredito = $('#cartaocredito')

    $mpag.hide()
    $parcels.hide()
    $cartaocredito.hide()
    const session = JSON.parse(localStorage.getItem('usuarioLogado'))

    if (!session) {
      location.href = `${self.$SiteUrl}/login?redirectTo=${location.href}`
    }

    if (session.CodigoPedido != -1) {
      this.formKombi.codigoKombiInt = session.CodigoPedido
    } else if (session.CodigoOrcamento != -1) {
      this.formKombi.codigoKombiInt = session.CodigoOrcamento
    }

    const formaPagamento = localStorage.getItem('formaPagamento') || 'vista'

    this.formaPagOnChange({ target: { value: formaPagamento } })

    if (session.CodigoOrcamento == -1 && this.$route.params.tipo === 'cotacao') {
      location.href = `${self.$SiteUrl}/loja/meu-carrinho/carrinho`
    }

    this.getTipoPedido()

    this.ValidaZeroICMS()
  },
  data() {
    return {
      loadMounted: true,
      updateParcela: true,
      isQuotation: false,
      isVendaDireta: false,
      isConsumoProprio: false,
      isPossivelConfirmacaoAut: false,
      session: {},
      faturamentos: [],
      isCalculating: false,
      isProcessing: false,
      formAddProdutos: {
        codigo: new this.$formInput(false),
        quantidade: new this.$formInput(false),
      },
      formKombi: {
        changeParcela: false,
        updateProdutos: false,
        vendaNaoRealizaAcompanhamento: null,
        updateTotal: true,
        permission: true,
        codigoKombiInt: 0,
        loading: true,
        inStockText: '',
        outStockText: '',
        attemptSubmit: false,
        kombiCode: '',
        tipo: this.$route.params.tipo,
        clienteInfo: [],
        taxesInfo: [],
        dateToArrive: '05/07/2019',
        vendedor: new this.$formInput(true),
        formaPag: new this.$formInput(true),
        meioPag: new this.$formInput(false),
        parcelas: new this.$formInput(false),
        cartaocredito: new this.$formInput(false),
        bandeiraCartao: new this.$formInput(false, localStorage.bandeiraCartao || '1'),
        inStockList: [],
        outStockList: [],
        vendedores: [],
        optionsParcelas: [],
        optionsCartaoCredito: [],
        codigoParcela: 0,
        codigoVendedor: 0,
        totalCarrinho: '',
        totalCarrinhoCartaoCredito: '',
        baseCalculoFrete: 0,
        quantidadeParcelasCartao: 0,
        pagCartaoCredito: false,
        codigoCliente: '',
        installmentNumber: 0,
      },
      columnsCli: [
        { label: 'Código', field: 'codigo' },
        { label: 'CPF/CNPJ', field: 'cpfCnpj' },
        { label: 'Razão Social', field: 'razaoSoci' },
        { label: 'UF', field: 'uf' },
      ],
      columnsTaxes: [
        { label: 'IPI', field: 'ipi', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Out. Desp.', field: 'outDesp', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Base Calc. Icms', field: 'bcIcms', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Icms', field: 'icms', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Base Calc. Icms Retido', field: 'bcrIcms', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Icms Subst. Trib.', field: 'icmsSubT', tdClass: 'align-center-td', thClass: 'align-center-td' },
        { label: 'Total produtos', field: 'totalPord', tdClass: 'align-center-td', thClass: 'align-center-td' },
      ],
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false,
      },
      liberaPagamentoCartaoCredito: false,
      firstLoad: true,
      formulario: {},
      loadingCardValues: false,
      isUpdatingQty: false,
      reloadProductsList: false,
      reativacao: false,
    }
  },
  watch: {
    'formKombi.vendaNaoRealizaAcompanhamento': function (v) {
      var self = this
      const api = axios.create({
        withCredentials: true,
      })
      api
        .post(this.$apiUrl + 'Carrinho.svc/alterouConfirmacaoAutomatica', {
          codigoPedido: self.formKombi.codigoKombiInt,
          valor: v,
        })
        .then((response) => {})
    },
    'formKombi.inStockList.length': function (v) {
      //Oculta a lista quando não houve produtos em estoque
      var $inStock = $('#in-stock-list')

      if (v > 0) {
        $inStock.show()
      } else {
        $inStock.hide()
      }
    },
    'formKombi.outStockList.length': function (v) {
      //Oculta a lista quando não houve produtos em com previsão de chegada
      var $outStock = $('#out-stock-list')

      if (v > 0) {
        $outStock.show()
      } else {
        $outStock.hide()
      }
    },
    'formKombi.parcelas.value': function (v) {
      const alterarParcela = v !== null && v.code && v.code !== this.formKombi.codigoParcela

      if (!alterarParcela) {
        return
      }

      localStorage.parcelaSelecionada = v.label

      let xhr = new XMLHttpRequest()

      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarParcela')
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true

      xhr.onload = () => {
        if (xhr.status == 200) {
          let response = JSON.parse(xhr.responseText)
          this.reloadProductsList = true
          this.reloadTotalCarrinho()

          if (!response.includes('{"T":"","Message":""}')) {
            swal({
              title: 'Aviso',
              text: response,
              icon: 'warning',
            })
          }
        }
      }

      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
          codigoParcela: v.code,
        })
      )
    },
  },
  computed: {
    totalItems: function () {
      return this.formKombi.outStockList.length + this.formKombi.inStockList.length
    },
    formErrors: function () {
      const errors = Object.keys(this.formKombi).filter(
        (key) => this.formKombi[key].required && this.formKombi[key].validation && !this.formKombi[key].validation.status
      )
      return errors.length
    },
  },
  methods: {
    formaPagOnChange: async function (valuepag) {
      const v = valuepag.target.value
      const $mpag = $('#pay-method')
      const $parcels = $('#parcels')
      const $cartaocredito = $('#cartaocredito')

      const dadosCliente = JSON.parse(localStorage.getItem('usuarioLogado')).DadosCliente
      this.isCalculating = true
      this.formKombi.updateProdutos = false

      this.formKombi.parcelas = new this.$formInput(false)
      this.formKombi.parcelas.required = v == 'prazo'
      this.formKombi.meioPag.required = v == 'vista'
      this.formKombi.changeParcela = v == 'vista'
      this.formKombi.cartaocredito = new this.$formInput(false)
      this.formKombi.cartaocredito.required = v == 'cartaocredito'
      this.formKombi.codigoParcela = v == 'vista' ? 0 : this.formKombi.codigoParcela
      this.formKombi.totalCarrinhoCartaoCredito = ''
      this.formKombi.pagCartaoCredito = false
      this.formKombi.totalCarrinho = '------'

      const formaPagamentoAnterior = localStorage.formaPagamento
      localStorage.formaPagamento = v

      this.reloadProductsList = true

      if (v == 'vista') {
        this.formKombi.vendaNaoRealizaAcompanhamento = 1

        if (!this.formKombi.meioPag.value) this.formKombi.meioPag.value = this.getMeiosPag()[0]
        localStorage.meioPagamento = this.formKombi.meioPag.value != null ? this.formKombi.meioPag.value.label : 'Boleto / PIX'
        this.verificaConfirmacaoAutomatica()

        this.formKombi.changeParcela = true
        this.formKombi.pagCartaoCredito = false

        localStorage.removeItem('parcelaSelecionada')

        $mpag.show()
        $parcels.hide()
        $cartaocredito.hide()

        const dataAlterarTipoPagamento = {
          codigoPedido: this.formKombi.codigoKombiInt,
          cdCliente: this.formKombi.codigoCliente,
          nrFilial: 1,
          tipoVenda: 0,
          formaPagamento: 3,
        }

        const response = await CarrinhoService.AlterarTipoPagamento(this.$apiUrl, dataAlterarTipoPagamento)

        if (response === '{"T":"","Message":""}') {
          this.alterarMeioPagamento({ label: 'Boleto / PIX' })
          this.reloadTotalCarrinho()
        } else {
          this.formKombi.formaPag.value = formaPagamentoAnterior
          if (response) {
            swal({
              title: 'Aviso',
              text: response,
              icon: 'warning',
            })
          }
        }
      } else if (v == 'prazo') {
        this.formKombi.vendaNaoRealizaAcompanhamento = 0
        $mpag.hide()
        $cartaocredito.hide()
        $parcels.show()

        localStorage.removeItem('meioPagamento')
        this.formKombi.meioPag = new this.$formInput(false)
        this.formKombi.pagCartaoCredito = false

        if (dadosCliente.CliTipocadastro !== 0) {
          const dataAlterarTipoPagamento = {
            codigoPedido: this.formKombi.codigoKombiInt,
            cdCliente: dadosCliente.CliCodigo,
            nrFilial: 1,
            tipoVenda: 1,
            formaPagamento: 0,
          }

          const response = await CarrinhoService.AlterarTipoPagamento(this.$apiUrl, dataAlterarTipoPagamento)

          if (response === '{"T":"","Message":""}') {
            if (this.formKombi.optionsParcelas.length === 0) await this.getParcelas()
            this.reloadTotalCarrinho()
          } else {
            this.formKombi.formaPag.value = formaPagamentoAnterior
            this.formKombi.permission = false
            if (response) {
              swal({
                title: 'Aviso',
                text: response,
                icon: 'warning',
              })
            }
          }
        } else {
          this.formKombi.formaPag.value = 'vista'
          this.formKombi.permission = false
          swal({
            title: 'Aviso',
            text: 'Você não tem permissão para selecionar esta forma de pagamento!',
            icon: 'warning',
          })
        }
      } else if (v == 'cartaocredito') {
        $('#formas-pagamento .inline-radio>input[type=radio]').attr('checked', false)
        $mpag.hide()
        $parcels.hide()
        $cartaocredito.attr('checked', true)
        $cartaocredito.show()

        this.alterarBandeiraCartao()

        this.formKombi.bandeiraCartao.required = true
        this.formKombi.vendaNaoRealizaAcompanhamento = 0
        this.formKombi.pagCartaoCredito = true
        this.formKombi.meioPag.value = null
        localStorage.removeItem('meioPagamento')
      } else {
        this.formKombi.formaPag.value = formaPagamentoAnterior
        this.formKombi.permission = false
        swal({
          title: 'Aviso',
          text: 'Você não tem permissão para selecionar esta forma de pagamento!',
          icon: 'warning',
        })
      }
    },
    getTipoPedido: function () {
      const response = localStorage.getItem('GetTipoPedido')

      if (response.includes('DIRETA')) {
        this.isVendaDireta = true
      } else if (response.includes('IMOBILIZADO')) {
        this.isVendaDireta = false
        this.isConsumoProprio = false
      } else {
        this.isVendaDireta = false
        this.isConsumoProprio = false
      }

      if (!this.isVendaDireta) {
        this.reloadProductsList = localStorage.formaPagamento !== 'cartaocredito'
        this.dadosPedido()
      } else {
        location.href = `${this.$SiteUrl}/loja/meu-carrinho-venda-direta/` + this.$route.params.tipo
      }
    },
    verificaConfirmacaoAutomatica: function () {
      var self = this
      const api = axios.create({
        withCredentials: true,
      })
      api
        .post(this.$apiUrl + 'Carrinho.svc/verificaConfirmacaoAutomatica', {
          cod_pedido: this.formKombi.codigoKombiInt,
        })
        .then((response) => {
          self.isPossivelConfirmacaoAut = response.data
          if (self.isPossivelConfirmacaoAut == false) {
            self.formKombi.vendaNaoRealizaAcompanhamento = 1
          }
        })
    },
    dadosProdutos: function () {
      let localStorageProducts = []
      localStorage.products = ''

      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          if (xhr.responseText != '' && xhr.responseText != null) {
            let json = JSON.parse(xhr.responseText)

            this.faturamentos = json
            this.faturamentos.forEach((faturamento) => {
              this.formKombi.inStockList = []
              this.formKombi.outStockList = []

              faturamento.Produtos.forEach((produto) => {
                let item = {}
                item.code = produto.Codigo
                item.dv = produto.Dv
                item.img = produto.UrlImagem
                item.desc = produto.Descricao
                item.qtde = produto.QtdePedido.replace(',00', '')
                item.unitV = produto.ValorUnitario
                item.prodPai = produto.ProdutoPai
                // item.taxes = [{icms: 0, reduct: 0, ppb: 0, ipi: 0, cfop: 0, ncm: 0, mva: 0}]
                // item.origin = ''

                let dataLayerProduct = {
                  sku: `${produto.Codigo}-${produto.Dv}`,
                  desc: produto.Descricao,
                  price: produto.ValorUnitarioRevenda,
                  quant: produto.QtdePedido,
                }

                localStorageProducts.push(dataLayerProduct)

                axios
                  .post(this.$apiUrl + 'Carrinho.svc/InformativoImpostos', {
                    codigoPedido: this.formKombi.codigoKombiInt,
                    prd_codigo: item.code,
                  })
                  .then((response) => {
                    let impostos = response.data

                    item.taxes = [
                      {
                        icms: impostos.Icms,
                        reduct: impostos.Reducao,
                        ppb: impostos.Ppb,
                        ipi: impostos.Ipi,
                        cfop: impostos.Cfop,
                        ncm: impostos.Nbm,
                        mva: impostos.Mva,
                      },
                    ]

                    item.origin = impostos.Origem

                    if (faturamento.TextoFaturamento.includes('disponibilidade')) this.formKombi.inStockList.push(item)
                    else this.formKombi.outStockList.push(item)
                  })
              })

              if (faturamento.TextoFaturamento.includes('disponibilidade')) this.formKombi.inStockText = faturamento.TextoFaturamento
              else this.formKombi.outStockText = faturamento.TextoFaturamento
            })

            localStorage.products = JSON.stringify(localStorageProducts)
            this.formKombi.loading = false

            this.carregaDataLayerCheckout(JSON.parse(localStorage.products))
          }
        }
      }
      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/LoadProducts')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
        })
      )
    },
    dadosPedido: async function () {
      const self = this
      let pedidoParametro = 0
      if (self.formKombi.codigoKombiInt === -1) {
        swal({
          title: 'Nenhuma kombi/cotação foram encontrados',
          buttons: 'Ok',
          dangerMode: true,
          icon: 'error',
        }).then(() => {
          location.href = `${self.$SiteUrl}/loja`
        })
      } else {
        self.isCalculating = true
        if (self.session.CodigoPedido != -1) {
          pedidoParametro = self.session.CodigoPedido
          self.isQuotation = false
        } else if (self.session.CodigoOrcamento != -1) {
          pedidoParametro = self.session.CodigoOrcamento
          self.isQuotation = true
        }

        try {
          const json = await CarrinhoService.CarregarFormulario(self.$apiUrl, pedidoParametro, self.isQuotation)
          self.formulario = json

          const cliente = {
            razaoSoci: json.Razao_social_cliente,
            codigo: `${json.Codigo_cliente}-${json.Dv_cliente}`,
            cpfCnpj: json.Cnpj_cliente,
            uf: json.Uf_cliente,
            carteira: json.CarteiraCliente,
          }

          self.reativacao = json.AlteraVendedor

          const impostos = {
            ipi: json.Total_ip,
            outDesp: json.Despesas_acessorias,
            bcIcms: json.Total_base_icms,
            icms: json.Total_icms,
            bcrIcms: json.Total_base_icms_retido,
            icmsSubT: json.Total_icms_retido,
            totalPord: json.Total_produtos,
          }

          if (self.loadMounted || self.isUpdatingQty) {
            const $mpag = $('#pay-method')
            const $parcels = $('#parcels')
            const $cartaocredito = $('#cartaocredito')
            self.formKombi.codigoParcela = json.Codigo_parcela

            if (self.formKombi.codigoVendedor == 0) self.getVendedores()

            self.formKombi.codigoVendedor = json.Vendedor

            const formasPag = self.payForms()

            let formaPagSelecionado = formasPag.filter((c) => {
              const vista = c.code === json.Tipo_venda && c.value === 'vista'
              const prazo = json.Tipo_venda === 1 && c.code !== 15 && c.value === 'prazo' && !self.formKombi.pagCartaoCredito
              const cartao = json.Tipo_venda === 1 && c.code === 15 && c.value === 'cartaocredito' && self.formKombi.pagCartaoCredito
              if (vista) return true
              if (prazo) return true
              return cartao
            })[0]

            self.formKombi.formaPag.value = formaPagSelecionado.value

            if (self.formKombi.formaPag.value === 'vista') {
              let meiosPag = self.getMeiosPag()
              let meioPagSelecionado = meiosPag.filter((c) => c.code == json.Forma_pagamento)
              if (meioPagSelecionado.length > 0) self.formKombi.meioPag.value = meioPagSelecionado[0]
            }

            if (self.formKombi.formaPag.value === 'prazo' && self.updateParcela) {
              await self.getParcelas()
              $mpag.hide()
              $cartaocredito.hide()
              $parcels.show()
            }

            if (self.formKombi.formaPag.value === 'cartaocredito') {
              self.getParcelasCartaoCredito(json.Codigo_pedido)
              $mpag.hide()
              $parcels.hide()
              $cartaocredito.attr('checked', true)
              $cartaocredito.show()
            }
          }

          self.formKombi.taxesInfo = []
          self.formKombi.clienteInfo = []
          self.formKombi.taxesInfo.push(impostos)
          self.formKombi.clienteInfo.push(cliente)

          self.formKombi.totalCarrinho = self.formatCurrency(json.Total_nota_fiscal)
          self.formKombi.totalAmountClienteCreditCard = json.Valor_com_juros_cartao
          self.formKombi.installmentNumber = json.Parcela_cartao_credito
          self.formKombi.baseCalculoFrete = json.Total_produtos_originais

          self.formKombi.kombiCode = json.Codigo_pedido + '-' + json.Dv_pedido
          self.formKombi.codigoCliente = self.formKombi.clienteInfo[0].codigo.split('-')[0]

          if ((!self.formKombi.updateTotal && self.formKombi.updateProdutos && self.updateParcela) || self.reloadProductsList) {
            self.dadosProdutos()
          }

          self.reloadProductsList = false
          self.isUpdatingQty = false
          self.loadMounted = false

          self.isCalculating = false
        } catch (error) {
          console.log(error)
        }
      }
    },
    updateAfterSelectFrete() {
      this.isCalculating = true
      this.loadMounted = true
      this.reloadProductsList = true
      this.formKombi.totalCarrinho = '------'
      this.reloadTotalCarrinho()
    },
    clearFormaPagamento() {
      localStorage.formaPagamento = ''
      localStorage.removeItem('parcelaSelecionada')
    },
    reloadTotalCarrinho() {
      this.formKombi.updateTotal = false
      this.isCalculating = true
      this.formKombi.totalCarrinho = '------'
      this.dadosPedido()
    },
    addProduto: function () {
      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          var self = this
          if (xhr.responseText != '' && xhr.responseText != null) {
            let json = JSON.parse(xhr.responseText)
            if (json == 'Carrinho Alterado') {
              self.verificaConfirmacaoAutomatica()
              this.ValidaZeroICMS()
              location.reload()
            } else {
              let span = document.createElement('span')
              span.innerHTML = json

              swal({
                title: 'Aviso',
                content: span,
                icon: 'warning',
              })
            }
          }
        }
      }
      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AdicionarProduto')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true

      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
          prd_codigo: this.formAddProdutos.codigo.value.split('-')[0],
          produtoDv: this.formAddProdutos.codigo.value.split('-')[1],
          qtde: parseInt(this.formAddProdutos.quantidade.value),
        })
      )
    },
    removeInStock: function (prodIndex) {
      let produtoatual
      this.formKombi.inStockList.forEach(function (element, index) {
        if (prodIndex == index) {
          produtoatual = element
        }
      })
      swal({
        title: 'Exclusão de produto ' + produtoatual.code + '-' + produtoatual.dv,
        text: 'Confirma a exclusão?',
        buttons: ['Cancelar', 'Excluir'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          var xhr = new XMLHttpRequest()
          xhr.onload = () => {
            if (xhr.status == 200) {
              if (xhr.responseText != '' && xhr.responseText != null) {
                let json = JSON.parse(xhr.responseText)

                this.clearFormaPagamento()
                location.reload()
              }
            }
          }
          xhr.open('POST', this.$apiUrl + 'Carrinho.svc/RemoverProduto')
          xhr.setRequestHeader('Content-Type', 'application/json')
          xhr.withCredentials = true
          xhr.send(
            JSON.stringify({
              codigoPedido: this.formKombi.codigoKombiInt,
              prd_codigo: produtoatual.code,
              cdCliente: this.formKombi.clienteInfo.codigo,
              nrFilial: 1,
            })
          )
        } else {
          return
        }
      })
    },
    removeOutStock: function (prodIndex) {
      let produtoatual
      this.formKombi.outStockList.forEach(function (element, index) {
        if (prodIndex == index) {
          produtoatual = element
        }
      })
      swal({
        title: 'Exclusão de produto ' + produtoatual.code + '-' + produtoatual.dv,
        text: 'Confirma a exclusão?',
        buttons: ['Cancelar', 'Excluir'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          var xhr = new XMLHttpRequest()
          xhr.onload = () => {
            if (xhr.status == 200) {
              if (xhr.responseText != '' && xhr.responseText != null) {
                let json = JSON.parse(xhr.responseText)

                this.clearFormaPagamento()
                location.reload()
              }
            }
          }
          xhr.open('POST', this.$apiUrl + 'Carrinho.svc/RemoverProduto')
          xhr.setRequestHeader('Content-Type', 'application/json')
          xhr.withCredentials = true
          xhr.send(
            JSON.stringify({
              codigoPedido: this.formKombi.codigoKombiInt,
              prd_codigo: produtoatual.code,
              cdCliente: this.formKombi.clienteInfo.codigo,
              nrFilial: 1,
            })
          )
        } else {
          return
        }
      })
    },
    continueAction: async function () {
      this.formKombi.attemptSubmit = true

      if (await this.validarDataFaturamentos()) {
        await this.dividirPedidoPorData()
        return
      }

      if (
        this.formKombi.formaPag.value !== 'prazo' &&
        this.formKombi.formaPag.value !== 'vista' &&
        this.formKombi.formaPag.value !== 'cartaocredito'
      ) {
        swal({
          title: 'Aviso',
          text: 'Selecione uma forma de pagamento!',
          icon: 'warning',
        })
      } else if (this.formKombi.formaPag.value === 'prazo' && this.formKombi.parcelas.value && this.formKombi.parcelas.value.label == 'Parcelas') {
        swal({
          title: 'Aviso',
          text: 'Selecione a parcela para pagamento a prazo!',
          icon: 'warning',
        })
      } else if (
        (this.formKombi.formaPag.value === 'cartaocredito' && this.formKombi.cartaocredito.value === null) ||
        this.formKombi.bandeiraCartao.value === null
      ) {
        swal({
          title: 'Aviso',
          text: 'Selecione a quantidade de parcelas para cartão de crédito e a bandeira!',
          icon: 'warning',
        })
      } else {
        if (this.formErrors === 0) {
          this.finishAction()
        } else {
          swal({
            title: 'Aviso',
            text: 'Preencha os campos obrigatórios',
            icon: 'warning',
          })
        }
      }
    },
    finishAction: function () {
      if (this.formKombi.totalAmountClienteCreditCard > 0) {
        var content = document.createElement('div')

        var logoBandeira = ''

        if (this.formKombi.bandeiraCartao.value == '1') logoBandeira = '/assets/images/logo-bandeiras/Visa.png'
        else if (this.formKombi.bandeiraCartao.value == '2') logoBandeira = '/assets/images/logo-bandeiras/Master.png'
        else if (this.formKombi.bandeiraCartao.value == '3') logoBandeira = '/assets/images/logo-bandeiras/Elo.png'
        else if (this.formKombi.bandeiraCartao.value == '4') logoBandeira = '/assets/images/logo-bandeiras/Hipercard.png'
        else if (this.formKombi.bandeiraCartao.value == '5') logoBandeira = '/assets/images/logo-bandeiras/Amex.png'

        content.innerHTML =
          'Valor final após transportadora escolhida: <strong>' +
          this.formatCurrency(this.formKombi.totalAmountClienteCreditCard) +
          '</strong><br>Parcelas: <strong>' +
          this.formKombi.quantidadeParcelasCartao +
          'x de ' +
          this.formatCurrency(this.formKombi.totalAmountClienteCreditCard / this.formKombi.quantidadeParcelasCartao) +
          '</strong>' +
          '</strong><br>Bandeira: <img style = ' +
          'height:35px ' +
          +'' +
          ' src = ' +
          logoBandeira +
          ' >'

        swal({
          icon: 'warning',
          title: 'Forma de pagamento escolhida: Cartão de Crédito.',
          content: content,
          buttons: {
            cancel: 'Cancelar',
            alterar: { text: 'Alterar parcelamento' },
            finalizar: { text: 'Finalizar', className: 'bg-primary' },
          },
        }).then((value) => {
          switch (value) {
            case 'finalizar':
              this.finalizar(true)
              break
            default:
              break
          }
        })
      } else {
        swal({
          title: 'Finalizar Pedido',
          text: 'Deseja finalizar o pedido?',
          buttons: ['Cancelar', 'Finalizar'],
        }).then((confirmou) => {
          this.finalizar(confirmou)
        })
      }
    },
    finalizar: function (confirmou) {
      this.isProcessing = true
      if (confirmou) {
        const dadosCliente = JSON.parse(localStorage.getItem('usuarioLogado')).DadosCliente
        var xhr = new XMLHttpRequest()
        xhr.onload = () => {
          if (xhr.status == 200) {
            if (xhr.responseText != '' && xhr.responseText != null) {
              let json = JSON.parse(xhr.responseText)

              if (json.includes('OK')) {
                localStorage.vendedor = 'INTERNET'
                localStorage.formaPagamento = 'vista'
                localStorage.meioPagamento = 'Boleto / PIX'
                localStorage.numCartaoBNDS = ''
                localStorage.validadeBNDS = ''
                localStorage.bandeiraBNDS = ''
                localStorage.bancoBNDS = ''
                localStorage.parcelaBNDS = ''
                localStorage.parcelaSelecionada = 'Parcelas'
                localStorage.cifKombi = ''
                localStorage.fobKombi = ''
                localStorage.bandeiraCartao = ''

                this.removeAgendamentoLocal(this.formKombi.codigoKombiInt)

                // Google tag Manager - gtm.js
                let buy = {
                  event: 'purchase',
                  pageType: 'transactionSuccess',
                  transaction_id: this.formKombi.codigoKombiInt,
                  value: this.formKombi.totalCarrinho,
                  items: JSON.parse(localStorage.products),
                }

                this.$gtm.push(buy)
                localStorage.buyDataLayer = JSON.stringify(buy)

                const jsonUser = window.localStorage.getItem('usuarioLogado')
                const dadosPedido = JSON.parse(jsonUser)

                this.carregaDataLayerPurchase(JSON.parse(localStorage.products), dadosPedido)

                localStorage.removeItem('products')

                if (this.formKombi.totalCarrinho > 0) {
                  let content = document.createElement('div')
                  content.innerHTML =
                    'Enviaremos para você um link de pagamento com as informações do pedido, após ele ser confirmado pelo seu vendedor.'

                  swal({
                    icon: 'success',
                    title: 'Pedido confirmado para Cartão de Crédito.',
                    content: content,
                    button: 'Ok',
                  }).then(() => {
                    location.href = '/carrinho-fechado'
                  })
                } else {
                  location.href = '/carrinho-fechado'
                }
              } else {
                this.isProcessing = false
                swal({
                  title: 'Aviso',
                  text: json,
                  icon: 'warning',
                  button: 'Ok',
                })
                return
              }
            }
          }
        }
        xhr.open('POST', this.$apiUrl + 'Carrinho.svc/ConfirmarPedido')
        xhr.setRequestHeader('Content-Type', 'application/json')
        xhr.withCredentials = true
        xhr.send(
          JSON.stringify({
            codigoPedido: this.formKombi.codigoKombiInt,
            nomeUsuarioComprador: dadosCliente.UserNome,
          })
        )
      } else {
        this.isProcessing = false
        swal({
          title: 'Cancelada a finalização do pedido.',
          button: 'Ok',
        })
        return
      }
    },
    deleteAction: function () {
      const self = this
      swal({
        title: 'Exclusão do carrinho',
        text: 'Deseja excluir o carrinho ' + this.formKombi.kombiCode,
        buttons: ['Cancelar', 'Excluir'],
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          var xhr = new XMLHttpRequest()
          xhr.onload = () => {
            if (xhr.status == 200) {
              if (xhr.responseText != '' && xhr.responseText != null) {
                let json = JSON.parse(xhr.responseText)
                this.removeAgendamentoLocal(this.formKombi.codigoKombiInt)

                localStorage.vendedor = 'INTERNET'
                localStorage.formaPagamento = 'vista'
                localStorage.meioPagamento = 'Boleto / PIX'
                localStorage.numCartaoBNDS = ''
                localStorage.validadeBNDS = ''
                localStorage.bandeiraBNDS = ''
                localStorage.bancoBNDS = ''
                localStorage.parcelaBNDS = ''
                localStorage.parcelaSelecionada = 'Parcelas'
                localStorage.cifKombi = ''
                localStorage.fobKombi = ''
                localStorage.bandeiraCartao = ''

                location.href = `${self.$SiteUrl}/loja`
              }
            }
          }
          xhr.open('POST', this.$apiUrl + 'Carrinho.svc/CancelarPedido')
          xhr.setRequestHeader('Content-Type', 'application/json')
          xhr.withCredentials = true
          xhr.send(
            JSON.stringify({
              codigoPedido: this.formKombi.codigoKombiInt,
            })
          )
        } else {
          return
        }
      })
    },
    updateQt: function (product) {
      this.isCalculating = true

      var xhr = new XMLHttpRequest()
      xhr.onload = () => {
        if (xhr.status == 200) {
          let json = JSON.parse(xhr.responseText)

          if (json === '') {
            this.isUpdatingQty = true

            this.dadosPedido()
          } else {
            let span = document.createElement('span')
            span.innerHTML = json

            swal({
              title: 'Aviso',
              content: span,
              icon: 'warning',
            })
          }
        }
        this.isCalculating = false
      }
      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarQtdePedido')
      xhr.setRequestHeader('Content-Type', 'application/json')
      xhr.withCredentials = true
      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
          prd_codigo: product.code,
          cdCliente: this.formKombi.clienteInfo.codigo,
          nrFilial: 1,
          qtde: product.qtde,
        })
      )
    },
    formatCurrency: function (v) {
      v = v.toString().replace(',', '.')
      //formata valores floats para moeda
      var formato = {
        minimumFractionDigits: 2,
        style: 'currency',
        currency: 'BRL',
      }
      return parseFloat(v).toLocaleString('pt-BR', formato)
    },
    payForms: function () {
      return [
        { code: 0, label: 'À vista', value: 'vista', visible: true },
        { code: 1, label: 'À prazo | Financiamentos', value: 'prazo', visible: true },
        { code: 15, label: 'Cartão de Crédito', value: 'cartaocredito', visible: this.liberaPagamentoCartaoCredito },
      ]
    },
    getFlags: function () {
      return [
        { code: 1, label: '', value: '1', visible: true, img: { src: '/assets/images/logo-bandeiras/Visa.png', height: 50, width: 50 } },
        { code: 2, label: '', value: '2', visible: true, img: { src: '/assets/images/logo-bandeiras/Master.png', height: 50, width: 50 } },
        { code: 3, label: '', value: '3', visible: true, img: { src: '/assets/images/logo-bandeiras/Elo.png', height: 50, width: 50 } },
        // { code: 4, label: "", value: "4", visible: true, img: { src: "/assets/images/logo-bandeiras/Hipercard.png", height: 50, width: 50 } },
        // { code: 5, label: "", value: "5", visible: true, img: { src: "/assets/images/logo-bandeiras/Amex.png", height: 50, width: 50 } },
      ]
    },
    getTodayDate: function () {
      return new Date().toLocaleDateString('pt-BR')
    },
    getVendedores: function () {
      const self = this

      $.ajax({
        url: this.$apiUrl + 'Usuarios.svc/getvendedores',
        dataType: 'json',
        type: 'GET',
        xhrFields: { withCredentials: true },
        success: (data) => {
          data.forEach((element) => {
            let vendedor = {}
            vendedor.code = element.Key
            vendedor.label = element.Value
            self.formKombi.vendedores.push(vendedor)
          })

          if (self.formKombi.codigoVendedor != 0) {
            let vendedores = self.formKombi.vendedores.filter((c) => c.code === self.formKombi.codigoVendedor)
            if (vendedores.length > 0) self.formKombi.vendedor.value = vendedores[0]
            else self.formKombi.vendedor.value = { code: 94, label: 'INTERNET' }

            this.formKombi.vendedor.validation.status = true
          }
        },
      })
    },
    getMeiosPag: function () {
      // COVID-19
      return [
        { code: 3, label: 'Boleto / PIX' },
        //{code: 1, label: "Dinheiro"},
        //{code: 0, label: "Cheque"}
      ]
    },
    getParcelas: async function () {
      this.formKombi.optionsParcelas = []

      const json = await CarrinhoService.GetParcelasPgtoPrazo(this.$apiUrl, {
        codigoPedido: this.formKombi.codigoKombiInt,
        empCodigo: 1,
      })

      json.forEach((element) => {
        let obj = {}
        obj.code = element.CodigoPagamento
        obj.label = element.DescricaoParaInternet
        this.formKombi.optionsParcelas.push(obj)
      })

      if (this.formKombi.formaPag.value === 'prazo') {
        let parc = this.formKombi.optionsParcelas.filter((p) => p.code === this.formKombi.codigoParcela)
        this.formKombi.parcelas = new this.$formInput(true, parc)
      }
    },
    getParcelasCartaoCredito: function (codigoPedidoCarrinho) {
      this.loadingCardValues = true
      this.formKombi.optionsCartaoCredito = []
      const bandeira = this.formKombi.bandeiraCartao.value
      axios
        .get(this.$apiUrl + `PagamentoCartao.svc/CreditCardInterestRates/${codigoPedidoCarrinho}/${bandeira}`)
        .then((response) => {
          if (response.data) {
            this.formKombi.optionsCartaoCredito = response.data.map((item) => {
              return {
                code: item.InstallmentCode,
                label:
                  item.InstallmentNumber +
                  'x de ' +
                  convertNumberToReal(item.FinalValue / item.InstallmentNumber) +
                  ' - ' +
                  convertNumberToReal(item.FinalValue),
                qtdParcelas: item.InstallmentNumber,
                finalValue: item.FinalValue,
              }
            })
          }
          this.loadingCardValues = false
          this.setParcelaCartaoCredito()
        })
        .catch(() => {
          swal({
            title: 'Erro ao carregar parcelas do Cartão de Crédito',
            icon: 'warning',
          })
        })
    },
    setParcelaCartaoCredito: function () {
      if (this.formKombi.formaPag.value === 'cartaocredito') {
        let parc = this.formKombi.optionsCartaoCredito.filter((p) => p.code === this.formKombi.codigoParcela)
        this.formKombi.cartaocredito = new this.$formInput(true, parc[0])

        if (this.firstLoad) {
          const totalCarrinho = parseFloat(this.formKombi.totalCarrinho.replace('R$', '').replaceAll('.', '').replace(',', '.'))
          this.formKombi.totalAmountClienteCreditCard = totalCarrinho
          this.firstLoad = false

          if (!!parc && parc[0] !== undefined) {
            this.atribuirTipoPagamentoCartaoCredito(parc[0])
          }
        }
      }
    },
    atribuirTipoPagamentoCartaoCredito: function (v, reload = true) {
      this.isCalculating = true
      this.formKombi.totalCarrinho = '------'
      const parcela = v || this.formKombi.cartaocredito.value

      if (this.formKombi.formaPag.value == 'cartaocredito' && parcela !== null && !!parcela.code) {
        if (this.formKombi.totalAmountClienteCreditCard == parcela.finalValue) reload = false

        const xhr = new XMLHttpRequest()
        this.formKombi.quantidadeParcelasCartao = parcela.qtdParcelas
        xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AtribuirTipoPagamentoCartaoCredito')
        xhr.setRequestHeader('Content-type', 'application/json')
        xhr.withCredentials = true

        xhr.send(
          JSON.stringify({
            codigoPedido: this.formKombi.codigoKombiInt,
            bandeira: this.formKombi.bandeiraCartao.value,
            codigoParcela: parcela.code,
          })
        )

        xhr.onload = () => {
          if (reload) {
            this.reloadProductsList = true
            this.reloadTotalCarrinho()
            this.formKombi.totalAmountClienteCreditCard = parcela.finalValue
          }
        }

        this.formKombi.codigoParcela = parcela.code
        // this.setParcelaCartaoCredito();
      }
    },
    async validarDataFaturamentos() {
      this.isProcessing = true
      return await axios
        .post(
          this.$apiUrl + 'Carrinho.svc/VerificaVariasDataFaturamento',
          {
            codigoPedido: this.formKombi.codigoKombiInt,
          },
          { withCredentials: true }
        )
        .then((response) => {
          if (response.data.length > 0 && !response.data.includes('Prêmio calculado é negativo')) return true
          else {
            return false
          }
        })
    },
    async dividirPedidoPorData() {
      return await axios
        .post(
          this.$apiUrl + 'Carrinho.svc/DividirPedidosPorDataFaturamento',
          {
            codigoPedido: this.formKombi.codigoKombiInt,
          },
          { withCredentials: true }
        )
        .then(() => {
          var span = document.createElement('span')
          span.innerHTML =
            'O seu pedido foi dividido em mais de um, pois possui produtos com data de faturamento diferentes.<br>' +
            'Por gentileza selecione a kombi que deseja trabalhar.'
          swal({
            title: 'Pedido dividido por data de faturamento!',
            content: span,
          }).then(() => {
            localStorage.removeItem('formaPagamento')
            localStorage.removeItem('meioPagamento')
            localStorage.parcelaSelecionada = 'Parcelas'
            location.href = this.$SiteUrl + '/loja'
          })
        })
    },
    ValidaZeroICMS: async function () {
      try {
        const response = await CarrinhoService.ValidaZeroICMS(this.$apiUrl)

        if (response === 200) {
          this.liberaPagamentoCartaoCredito = true
          return
        }
        this.liberaPagamentoCartaoCredito = false
      } catch (error) {
        console.log(error)
        this.liberaPagamentoCartaoCredito = false
      }
    },
    alterarMeioPagamento: async function (v) {
      if (!v) return
      this.isCalculating = true
      localStorage.meioPagamento = v.label
      this.verificaConfirmacaoAutomatica()
    },
    alterarBandeiraCartao: function (event) {
      this.formKombi.loading = true

      let bandeira = localStorage.bandeiraCartao || 1

      if (event) {
        bandeira = event.target.value
      }

      this.bandeira = bandeira
      localStorage.bandeiraCartao = bandeira

      this.firstLoad = true
      this.getParcelasCartaoCredito(this.formKombi.codigoKombiInt)

      const xhr = new XMLHttpRequest()

      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AtribuirTipoPagamentoCartaoCredito')
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true

      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
          bandeira: bandeira,
          codigoParcela: this.formKombi.codigoParcela,
          zerarTaxas: true,
        })
      )

      xhr.onload = () => {
        this.reloadProductsList = true
        this.reloadTotalCarrinho()
      }

      this.formKombi.loading = false
    },
    alterarVendedor: function (v) {
      let xhr = new XMLHttpRequest()

      localStorage.vendedor = v.label

      xhr.open('POST', this.$apiUrl + 'Carrinho.svc/AlterarVendedor')
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true

      xhr.send(
        JSON.stringify({
          codigoPedido: this.formKombi.codigoKombiInt,
          codigoVendedor: v.code,
        })
      )
    },
    alterarParcelaCartao: function (v) {
      this.atribuirTipoPagamentoCartaoCredito(v)
    },
    showLoading: function (val) {
      this.formKombi.totalCarrinho = '------'
      this.isCalculating = val
    },
    removeAgendamentoLocal: function (codigoPedido) {
      localStorage.removeItem('agendamentoPedido-' + codigoPedido)
    },
    carregaDataLayerCheckout(value) {
      if (dataLayer) {
        dataLayer.push({ ecommerce: null })
        dataLayer.push({
          event: 'begin_checkout',
          ecommerce: {
            items: value.map((x) => ({
              item_name: x.desc,
              item_id: x.sku,
              price: x.price,
              item_brand: x.desc,
              item_qtd: x.quant,
            })),
          },
        })
      }
    },
    carregaDataLayerPurchase(value, dadosPedido) {
      if (dataLayer) {
        dataLayer.push({ ecommerce: null })
        dataLayer.push({
          event: 'purchase',
          ecommerce: {
            transaction_id: dadosPedido.CodigoPedido,
            affiliation: dadosPedido.DadosCliente.CliRazaoSocial,
            value: dadosPedido.carrinhoTotalNotaFiscalSemFrete,
            currency: 'BRL',
            items: value.map((x, i) => ({
              item_name: x.desc,
              item_id: x.sku,
              price: x.prd_preco,
              item_brand: x.desc,
              index: i,
              quantity: x.quant,
            })),
          },
        })
      }
    },
  },
}
</script>
